import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { Typography, type MenuProps } from "antd";
import { StyledCustomerSettingsMenu } from "@app/customerAgent/settings/CustomerSettings/index.styled";
import { BiLogOut, BiUser } from "react-icons/bi";
import { useTypedDispatch } from "@lib/redux";
import { logout } from "@lib/redux/slices/auth";
import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { APP_VERSION } from "@lib/constants/AppConst";

export default function CustomerSettings() {
  const { messages } = useIntl();
  const { tab } = useParams();
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();

  const onClick: MenuProps["onClick"] = (e) => {
    console.log("click ", e);
  };

  return (
    <AppsContainer
      fullView
      title={messages[!!tab ? `common.${tab}` : "common.appConfigs"] as string}
      cardStyle={{ backgroundColor: "transparent" }}
    >
      <StyledFlex style={{ flexDirection: "column", gap: 16 }}>
        <StyledCustomerSettingsMenu
          onClick={onClick}
          style={{ width: 256 }}
          defaultSelectedKeys={["1"]}
          defaultOpenKeys={["sub1"]}
          mode="inline"
          items={[
            {
              key: "my-profile",
              label: <FormattedMessage id="common.myProfile" />,
              icon: <BiUser />,
              type: "item",
              onClick: () => {
                navigate("/my-profile");
              },
            },
            {
              type: "divider",
            },
            // {
            //   key: "sub4",
            //   label: "Navigation Three",
            //   children: [
            //     { key: "9", label: "Option 9" },
            //     { key: "10", label: "Option 10" },
            //     { key: "11", label: "Option 11" },
            //     { key: "12", label: "Option 12" },
            //   ],
            // },
            // {
            //   type: "divider",
            // },
            {
              key: "logout",
              label: <FormattedMessage id="common.logout" />,
              type: "item",
              icon: <BiLogOut />,
              onClick: () => {
                dispatch(logout());
              },
            },
          ]}
        />

        <Typography.Text copyable={{ text: APP_VERSION }}>
          Version : {APP_VERSION}
        </Typography.Text>
      </StyledFlex>
    </AppsContainer>
  );
}
